import {
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerDescription,
} from "@/components/ui/Drawer";
import { Button } from "@/components/ui/Button";
// import { Camera, Image, Paperclip } from "lucide-react";
import { Image, Paperclip } from "lucide-react";

interface UploadFileDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCameraClick?: () => void;
  onImageClick?: () => void;
  onFileClick?: () => void;
}

export const UploadFileDrawer = ({
  open,
  onOpenChange,
  // onCameraClick,
  onImageClick,
  onFileClick,
}: UploadFileDrawerProps) => {
  const handleOptionClick = (callback?: () => void) => {
    callback?.();
    onOpenChange(false);
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerTitle className="sr-only">选择上传方式</DrawerTitle>
        <DrawerDescription className="sr-only">
          请选择您要上传的内容类型
        </DrawerDescription>
        <div className="px-4 py-4">
          {/* 横向排列的按钮容器 */}
          <div className="flex gap-4 justify-start">
            <Button
              variant="outline"
              className="w-16 h-16 rounded-2xl flex flex-col items-center justify-center hover:bg-slate-50"
              onClick={() => handleOptionClick(onImageClick)}
            >
              <Image
                className="w-7 h-7 py-1"
                style={{ width: "1.5rem", height: "1.5rem" }}
              />
              <span className="text-sm">图片</span>
            </Button>

            <Button
              variant="outline"
              className="w-16 h-16 rounded-2xl flex flex-col items-center justify-center hover:bg-slate-50"
              onClick={() => handleOptionClick(onFileClick)}
            >
              <Paperclip
                className="w-7 h-7 py-1"
                style={{ width: "1.5rem", height: "1.5rem" }}
              />
              <span className="text-sm">附件</span>
            </Button>
          </div>
          <hr className="mt-4" />
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="w-full text-slate-500 hover:text-slate-700 h-10"
          >
            取消
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
